import React from 'react';
import Modal from '../../modal/Modal';
import { IoMdClose } from 'react-icons/io';
import { Button } from 'react-bootstrap';

var RewardSelectionModalError = function RewardSelectionModalError(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      action = props.action,
      handleApplyRewards = props.handleApplyRewards,
      handleRefresh = props.handleRefresh;
  var Copy = model.Copy,
      Description = model.Description,
      Header = model.Header,
      RetryButton = model.RetryButton;

  var handleRetry = function handleRetry() {
    hide();

    switch (action) {
      case 'apply':
        handleApplyRewards();
        break;

      case 'refresh':
        handleRefresh();
        break;
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    className: 'reward-selection-modal-error',
    show: show,
    hide: hide,
    hideCloseButton: false,
    backdrop: false,
    size: 'lg'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal-error__container container'
  }, /*#__PURE__*/React.createElement("button", {
    className: "reward-selection-modal-error__close",
    onClick: hide
  }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal-error__body'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'reward-selection-modal-error__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("span", {
    className: 'reward-selection-modal-error__description'
  }, Description === null || Description === void 0 ? void 0 : Description.value), /*#__PURE__*/React.createElement("span", {
    className: 'reward-selection-modal-error__copy'
  }, Copy === null || Copy === void 0 ? void 0 : Copy.value), /*#__PURE__*/React.createElement(Button, {
    className: 'cb-button-primary reward-selection-modal-error__retry-btn',
    onClick: handleRetry
  }, RetryButton === null || RetryButton === void 0 ? void 0 : RetryButton.value)))));
};

export default RewardSelectionModalError;